import { AloftDate, ReportJSON } from '@aloft/toolkit-shared';

import { SFREP_FNMA_2055_FORM_CODE } from './consts.ts';
import { create1004LikeFormNode } from './fnma1004.ts';

export const create2055FormNode = (
  doc: XMLDocument,
  effectiveDate: AloftDate | undefined,
  compSequence: string[],
  reportJSON: ReportJSON,
): HTMLElement =>
  create1004LikeFormNode(doc, effectiveDate, compSequence, reportJSON, SFREP_FNMA_2055_FORM_CODE);
